import React from 'react';
import './App.scss';
import { Link, Outlet, useLocation, useNavigate, Navigate } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction } from '@mui/material';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PlaceRoundedIcon from '@mui/icons-material/PlaceRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import SettingsIcon from '@mui/icons-material/Settings';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';

import { useSelector, useDispatch } from 'react-redux';

import FavuriteCitySelector from './Components/FavuriteCitySelector'

import TopBar from './Components/TopBar';

import { Alert, Snackbar, IconButton } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useTheme } from '@mui/material/styles';

function App() {
  let location = useLocation().pathname
  let favuriteCity = useSelector(state => state.city.city || null)
  const [selectCity, setSelectCity] = React.useState(favuriteCity ? false : true)
  const handleSelectCityOpen = () => setSelectCity(true)
  const handleSelectCityClose = () => setSelectCity(false)

  const [openAlert, setOpenAlert] = React.useState(false)

  const handleOpenAlert = () => {
    setOpenAlert(true)
  }

  const handleCloseAlert = () => {
    setOpenAlert(false)
  }


  if (location === '/')
    return (<Navigate to="/home" />)

  return (
    <div className="App">
      {
        favuriteCity ? 
          <><TopBar /> </>
          :
          <FavuriteCitySelector open={selectCity} handleOpen={handleSelectCityOpen} handleClose={handleSelectCityClose} />
      }
      <Outlet />
      <Snackbar
        open={openAlert}
        onClose={handleCloseAlert}
        action={<IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleCloseAlert}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>}
      >
        <Alert onClose={handleCloseAlert} severity="info" sx={{ width: '100%' }}>
          Attenzione: questo sito è una preview del sito finale, pertanto sarà soggetto ad imminenti miglioramenti
        </Alert>
      </Snackbar>
      <Navigation value={navigationNumberResolver[location]} />
    </div>
  );
}

function Navigation(props) {
  const theme = useTheme()
  return (
    <BottomNavigation
      showLabels
      value={props.value}
      style={{position:'fixed', bottom:'0px', left:'0px', width:'100%', boxShadow:'2px 2px 20px ' + theme.palette.boxShadow.main, zIndex:'2'}}
    >
      <BottomNavigationAction label="Home" icon={<HomeRoundedIcon />} component={Link} to="/home" />
      <BottomNavigationAction label="cronologia" icon={<HistoryRoundedIcon />} component={Link} to="/chronology" />
      <BottomNavigationAction label="mappa" icon={<MapRoundedIcon />} component={Link} to="/map" />
      <BottomNavigationAction label="impostazioni" icon={<SettingsIcon />} component={Link} to="/setting" />
    </BottomNavigation>
  )
}

const navigationNumberResolver = {
  '/home': 0,
  '/chronology': 1,
  '/map': 2,
  '/setting': 3
}

const cssVariables = (theme) => ({
  '@global': {
    ':root': {
      '--color-background-mui': theme.palette.background.main,
      '--color-secondary': theme.palette.secondary.main,
    }
  }
});

export default App
